import { render, staticRenderFns } from "./RoundSelectionDropdown.vue?vue&type=template&id=587139a6&scoped=true&"
import script from "./RoundSelectionDropdown.vue?vue&type=script&lang=js&"
export * from "./RoundSelectionDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587139a6",
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BDropdownText, BDropdown} from 'bootstrap-vue'
    installComponents(component, {BDropdownText, BDropdown})
    

export default component.exports